import { Sort, SortAsc, SortDesc } from 'assets/svg'

export const SORT_ICONS = {
  default: Sort,
  ASC: SortAsc,
  DESC: SortDesc,
}

export function sortLocalList<T, K extends keyof T>(list: Array<T>, key: K, order: 'ASC' | 'DESC' = 'ASC') {
  const sortedList = list.sort((first, second) => {
    const firstColumn = first[key] as string
    const secondColumn = second[key] as string
    return firstColumn.localeCompare(secondColumn)
  })

  if (order === 'DESC') {
    sortedList.reverse()
  }

  return sortedList
}


export function getCheckedEntriesOfCurrentPage(checkedRows: Array<number>, page: number, perPage: number) {
  return [...checkedRows].filter(checked => {
    const greaterThanOrEqualCondition = (page - 1) * perPage
    const lessThanCondition = page * perPage

    return checked >= greaterThanOrEqualCondition && checked < lessThanCondition
  }).map(row => {
    return row - ((page - 1) * perPage)
  })
}

export function addOffsetToEntry(selectedRow: number, page: number, perPage: number) {
  return selectedRow + ((page - 1) * perPage) 
}
